import { FormsModule } from "@angular/forms";
import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { RouterModule } from "@angular/router";

import { PagesRoutingModule } from "./pages-routing.module";
import { BiometricCaptureComponent } from "./biometric-capture/biometric-capture.component";
import { BsModalService, ModalModule } from "ngx-bootstrap";
import { FingerCaptureTestComponent } from "./finger-capture-test/finger-capture-test.component";

@NgModule({
  declarations: [BiometricCaptureComponent, FingerCaptureTestComponent],
  imports: [
    CommonModule,
    PagesRoutingModule,
    RouterModule,
    ModalModule,
    FormsModule,
  ],
  providers: [BsModalService],
})
export class PagesModule {}
